import './js/header.js';
// import './js/burger.js'
import './js/fire-base.js';
import './js/api.js';
// import './js/fetch_API_categories';
import './js/category.js';
import './js/top-books.js';
import './js/books-from-category.js';
import './js/modal-window.js';
import './js/support.js';
import './js/storage.js';
import './js/scroll-up.js';
import './js/refs.js';
import './js/markup.js';
import './js/footer.js'
import './js/dark-theme.js';
